// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"133a2189","455":"cd01c43a","977":"5e0e0a5f"}[chunkId] + ".chunk.js";
};